var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("투명경영")])])]), _c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/about/management/mobile.jpg",
      "alt": ""
    }
  }), _c('v-img', {
    staticClass: "d-none d-md-block",
    attrs: {
      "src": "/images/about/management/management.jpg",
      "alt": ""
    }
  })], 1), _c('section', {
    staticClass: "client-section pt-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--md"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("정직")]), _vm._v("하고 "), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("성실")]), _vm._v("하게 일하여 더욱 "), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("신뢰")]), _vm._v("받습니다.")]), _c('p', {
    staticClass: "grey-1--text mt-18 mt-md-24"
  }, [_vm._v(" 위드캔복지재단은 법과 윤리를 준수하며, 재정과 운영 전반에서 투명성과 책임성을 지키기 위해 최선을 다합니다. "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 우리는 후원자와 수혜자, 그리고 모든 이해관계자에게 신뢰받는 기관이 되기 위해 아래와 같은 원칙을 실천하고 있습니다. ")])]), _c('ul', {
    staticClass: "management-list"
  }, [_c('li', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "232"
    }
  }, [_c('div', {
    staticClass: "client-title--xl primary--text font-weight-bold"
  }, [_vm._v("첫째,")])])], 1), _c('v-col', [_c('div', {
    staticClass: "tit tit--sm mb-16"
  }, [_vm._v("투명한 재정 관리")]), _c('p', {
    staticClass: "client-title--sm line-height-16"
  }, [_vm._v("「사회복지법인 및 사회복지시설 재무회계규칙」, 「기부금품의 모집·사용 및 기부문화 활성화에 관한 법률」 관련 법령에 근거하여 후원금과 사업비 등 모든 수입·지출 내역을 투명하게 운영합니다. 재무현황을 정기적으로 정리해 공개하고, 외부 전문 회계법인을 통한 감사 과정을 거쳐 공정성을 확인받고 있습니다. 이를 통해 후원자와 사회가 안심하고 신뢰할 수 있는 환경을 조성하고자 합니다.")]), _c('v-btn', {
    staticClass: "mt-24",
    attrs: {
      "to": "/board/library",
      "large": "",
      "rounded": "pill",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "page-text page-text--lg white--text"
  }, [_vm._v("발간 자료실 바로가기")]), _c('v-icon', {
    staticClass: "ml-10",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1), _c('li', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "232"
    }
  }, [_c('div', {
    staticClass: "client-title--xl primary--text font-weight-bold"
  }, [_vm._v("둘째,")])])], 1), _c('v-col', [_c('div', {
    staticClass: "tit tit--sm mb-16"
  }, [_vm._v("공정하고 책임 있는 사업 운영")]), _c('p', {
    staticClass: "client-title--sm line-height-16"
  }, [_vm._v("국내 복지사업부터 국제개발협력사업에 이르기까지 모든 활동은 명확한 절차와 기준에 따라 진행되며, 각 사업 성과와 지원 현황은 정기 보고서와 홈페이지를 통해 공유합니다. 필요 시 직접 현장을 방문해 사업의 실질적 효과를 확인할 수 있도록 하여, 지원 과정에서도 투명성을 확보하고 있습니다.")]), _c('v-btn', {
    staticClass: "mt-24",
    attrs: {
      "to": "/board/story",
      "large": "",
      "rounded": "pill",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "page-text page-text--lg white--text"
  }, [_vm._v("사업기관 소식 바로가기")]), _c('v-icon', {
    staticClass: "ml-10",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1), _c('li', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "232"
    }
  }, [_c('div', {
    staticClass: "client-title--xl primary--text font-weight-bold"
  }, [_vm._v("셋째,")])])], 1), _c('v-col', [_c('div', {
    staticClass: "tit tit--sm mb-16"
  }, [_vm._v("윤리·인권 중심 경영")]), _c('p', {
    staticClass: "client-title--sm line-height-16"
  }, [_vm._v("위드캔복지재단은 사람 중심의 복지를 실천하기 위해 윤리강령을 제정하고, 임직원과 봉사자들이 이를 준수하도록 교육하고 있습니다. 모든 사업 과정에서 차별 없는 지원과 인권 보호를 최우선으로 삼아, 소외계층 누구나 존엄한 삶을 누릴 수 있도록 노력합니다.")]), _c('code-of-conduct-dialog', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attr = _ref.attr;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-24",
          attrs: {
            "large": "",
            "rounded": "pill",
            "color": "primary"
          }
        }, 'v-btn', attr, false), on), [_c('span', {
          staticClass: "page-text page-text--lg white--text"
        }, [_vm._v("위드캔복지재단 행동강령 바로가기")]), _c('v-icon', {
          staticClass: "ml-10",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-chevron-right")])], 1)];
      }
    }])
  })], 1)], 1)], 1), _c('li', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "232"
    }
  }, [_c('div', {
    staticClass: "client-title--xl primary--text font-weight-bold"
  }, [_vm._v("넷째,")])])], 1), _c('v-col', [_c('div', {
    staticClass: "tit tit--sm mb-16"
  }, [_vm._v("공시자료 및 정보 공개")]), _c('p', {
    staticClass: "client-title--sm line-height-16"
  }, [_vm._v("법령에 따라 정관, 사업보고서, 결산서류 등 주요 정보를 투명경영 페이지에서 공개하고 있습니다. 후원자와 국민 누구나 쉽게 접근할 수 있도록 관련 서류를 주기적으로 갱신하며, 재단 운영의 투명성을 높이고자 계속해서 소통 창구를 확대해 나갑니다.")]), _c('v-btn', {
    staticClass: "mt-24",
    attrs: {
      "to": "/about/board?code=notice",
      "large": "",
      "rounded": "pill",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "page-text page-text--lg white--text"
  }, [_vm._v("공시자료 바로가기")]), _c('v-icon', {
    staticClass: "ml-10",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1)])])], 1), _c('section', {
    staticClass: "client-section",
    attrs: {
      "id": "report"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('p', {
    staticClass: "client-title--sm font-weight-medium primary--text line-height-15"
  }, [_vm._v("Financial Reporting")]), _c('h2', {
    staticClass: "section-title"
  }, [_vm._v("재무보고")])]), _c('div', {
    staticClass: "section-title-wrap"
  }, [_c('p', {
    staticClass: "client-title--sm text-center"
  }, [_vm._v("2024년 1월 1일부터 12월 31일까지를 기준으로 작성된 위드캔복지재단의 수입 및 지출 내역을 공개합니다.")])]), _c('v-simple-table', {
    staticClass: "v-data-table--no-hover"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "7"
    }
  }, [_vm._v("수입내역")]), _c('th', [_vm._v("구분")]), _c('th', [_vm._v("결산")]), _c('th', [_vm._v("세부내용")])]), _c('tr', [_c('td', [_vm._v("재산수입")]), _c('td', [_vm._v("21,600,000")]), _c('td', [_vm._v("임대료수입")])]), _c('tr', [_c('td', [_vm._v("비지정후원금")]), _c('td', [_vm._v("163,468,700")]), _c('td', [_vm._v("CMS, 일시후원, 해피빈")])]), _c('tr', [_c('td', [_vm._v("지정후원금")]), _c('td', [_vm._v("190,718,513")]), _c('td', [_vm._v("정기 및 일시후원")])]), _c('tr', [_c('td', [_vm._v("이월금")]), _c('td', [_vm._v("248,181,769")]), _c('td', [_vm._v("통장 이월금")])]), _c('tr', [_c('td', [_vm._v("잡수입")]), _c('td', [_vm._v("214,452,180")]), _c('td', [_vm._v("장애인고용장려금, 예금이자")])]), _c('tr', [_c('td', [_c('strong', [_vm._v("총계")])]), _c('td', [_c('strong', [_vm._v("838,421,162")])]), _c('td')])])]), _c('v-simple-table', {
    staticClass: "v-data-table--no-hover"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "11"
    }
  }, [_vm._v("지출내역")]), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("구분")]), _c('th', [_vm._v("결산")]), _c('th', [_vm._v("세부내용")])]), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("국내사업")]), _c('td', [_vm._v("복지사업비")]), _c('td', [_vm._v("16,208,730")]), _c('td', [_vm._v("산하기관 연계사업")])]), _c('tr', [_c('td', [_vm._v("교육사업비")]), _c('td', [_vm._v("6,120,000")]), _c('td', [_vm._v("모금마케팅TF역량강화 교육 외")])]), _c('tr', [_c('td', [_vm._v("홍보사업 및 기타 사업비")]), _c('td', [_vm._v("14,369,500")]), _c('td', [_vm._v("모금캠페인 광고비, 영상제작비")])]), _c('tr', [_c('td', [_vm._v("종사자 교육 훈련비")]), _c('td', [_vm._v("11,289,860")]), _c('td', [_vm._v("종사자 워크숍 및 교육훈련비")])]), _c('tr', [_c('th', [_vm._v("해외사업")]), _c('td', [_vm._v("해외사업지원비")]), _c('td', [_vm._v("1,980,000")]), _c('td', [_vm._v("미얀마 소방지원사업")])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', [_vm._v("계")])]), _c('td', [_c('span', [_vm._v("49,968,090")])]), _c('td')]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("일반관리비")]), _c('td', [_vm._v("190,969,321")]), _c('td', [_vm._v("사무국 운영관리비")])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("시설전출금")]), _c('td', [_vm._v("147,100,000")]), _c('td', [_vm._v("법인전입금")])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("차년도 복지사업비(이월금)")]), _c('td', [_vm._v("450,383,751")]), _c('td', [_vm._v("차년도 사업수행준비금")])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("총계")])]), _c('td', [_c('strong', [_vm._v("838,421,162")])]), _c('td')])])]), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "mt-24",
    attrs: {
      "to": "/board/library",
      "large": "",
      "rounded": "pill",
      "color": "primary",
      "width": "160"
    }
  }, [_c('span', {
    staticClass: "page-text page-text--lg white--text"
  }, [_vm._v("자세히 보기")]), _c('v-icon', {
    staticClass: "ml-10",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "client-section pt-0"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "row--sm"
  }, _vm._l(_vm.boards, function (board, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('v-btn', {
      attrs: {
        "block": "",
        "color": "primary",
        "outlined": "",
        "x-large": "",
        "rounded": "pill"
      },
      on: {
        "click": function ($event) {
          var _board$files$;
          return _vm.download(`${board === null || board === void 0 ? void 0 : (_board$files$ = board.files[0]) === null || _board$files$ === void 0 ? void 0 : _board$files$.url}`, `${board === null || board === void 0 ? void 0 : board.subject}`);
        }
      }
    }, [_c('v-row', {
      attrs: {
        "justify": "space-between"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v(" " + _vm._s(board.subject) + " ")])]), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-icon', [_vm._v("mdi-text-box-search-outline")])], 1)], 1)], 1)], 1);
  }), 1)], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }